/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {useState} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {useQuery} from '@tanstack/react-query'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useToast} from '../../../components/Toats'
import {ListPlantsDetails} from './components/listPlants'
import {getClientOne} from '../../../../services/clientService'
import {UserResponsableClient} from './components/userResponsable'
import {UnitBranchLinkedClient} from './components/UnitBranchLinked'
import {CatalogItemImage} from '../../../catalogo/components/CatalogItemImage'
import {Loading} from '../../../components/Loadings/loading'
import {NotImported} from '../../../components/NotInformat'
import {CopyCode} from '../../../components/CopyCode'
import {NuklieConversationButton} from '../../../components/Nuklie'
import {ModalPlant} from '../../../components/modalPlant'
import {ModalPlantComposite} from '../../../components/modalPlantComposite'
import {ModalAddUpdateUser} from '../../../users/components/ModalAddEditUser'
import styles from './styles.module.css'

type Props = {
  id: string
  show: boolean
  handleClose: () => void
}

type DetailTab = 'plants' | 'responsable' | 'unitBranch'

const modalsRoot = document.getElementById('root-modals') || document.body

type InfoTagProps = {
  label: string
  icon: string
  value?: string | null
  iconColor?: string
  href?: string | null
}

const InfoTag = ({label, icon, value, iconColor, href}: InfoTagProps) => {
  const content = (
    <>
      <i
        className={`bi ${icon} fs-6 ${iconColor ? '' : 'text-gray-600'}`}
        style={iconColor ? {color: iconColor} : undefined}
      ></i>
      <span className={value ? undefined : styles.infoTagEmpty}>{value || 'Não informado'}</span>
    </>
  )

  return value && href ? (
    <a
      className={styles.infoTag}
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      title={`${label}: abrir em nova aba`}
    >
      {content}
    </a>
  ) : (
    <span className={styles.infoTag} title={label}>
      {content}
    </span>
  )
}

const whatsappLink = (phone?: string | null) => {
  let digits = String(phone || '').replace(/\D/g, '')
  if (digits.length < 10) return null
  if (!digits.startsWith('55') || digits.length <= 11) digits = `55${digits}`
  return `https://wa.me/${digits}`
}

const ModalDetailsClient = ({show, handleClose, id}: Props) => {
  const {toggleToast} = useToast()
  const [activeTab, setActiveTab] = useState<DetailTab>('plants')
  const [selectedPlant, setSelectedPlant] = useState<any | null>(null)
  const [editingUser, setEditingUser] = useState<any | null>(null)

  const closed = () => {
    setActiveTab('plants')
    handleClose()
  }

  const {
    data: client,
    isLoading: loading,
    refetch,
  } = useQuery({
    queryKey: ['getClientDetails', id, show],
    queryFn: async () => {
      try {
        return await getClientOne(id || '')
      } catch (error) {
        console.log(error)
        toggleToast('Erro ao buscar o cliente. ', 'error')
        return null
      }
    },
    enabled: show && !!id,
    staleTime: 1000 * 60 * 2,
  })

  /** Monta os dados no formato que o modal de usuário espera (mesmo padrão da listagem de usuários). */
  const openEditUser = () => {
    const user = client?.user
    if (!user) return
    setEditingUser({
      ...user,
      role: user.role?.slug || null,
      idClient: client?.id || null,
      idUnitBranch: client?.unitBranchs?.[0]?.id || null,
      idCompany: null,
    })
  }

  const tabs: {key: DetailTab; label: string; icon: string; count: number}[] = [
    {
      key: 'plants',
      label: 'Usinas',
      icon: 'bi-sun',
      count: (client?.plants || []).filter((plant: any) => !plant.deletePlant).length,
    },
    {key: 'responsable', label: 'Usuário de acesso', icon: 'bi-person-badge', count: client?.user ? 1 : 0},
    {key: 'unitBranch', label: 'Filiais', icon: 'bi-building', count: (client?.unitBranchs || []).length},
  ]

  return createPortal(
    <Modal
      id='kt_modal_details_client'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-950px'
      show={show}
      onHide={closed}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3
          className='card-title align-items-start flex-column'
          style={{display: 'flex', flexDirection: 'column'}}
        >
          <span className='card-label fw-bold fs-3 mb-1'>Detalhes do Cliente</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>
            {loading
              ? 'Carregando informações...'
              : client?.nameResponsible || 'Cliente não identificado'}
          </span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={closed}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-8 px-lg-10'>
        {loading ? (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{minHeight: '18rem'}}
          >
            <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}} />
          </div>
        ) : (
          <div className='d-flex flex-column flex-row-fluid'>
            <div className='d-flex flex-column flex-lg-row align-items-lg-center gap-5'>
              <div className={styles.avatar}>
                <CatalogItemImage
                  imageKey={client?.image}
                  size='lg'
                  fallbackIcon='/media/icons/duotune/communication/com006.svg'
                />
              </div>

              <div className='flex-grow-1'>
                <div className='d-flex align-items-center gap-3 fs-2 fw-bold text-gray-900 mb-1'>
                  {client?.nameResponsible || (
                    <NotImported className='fs-3 text-gray-400 fw-bold mb-0' />
                  )}
                  <NuklieConversationButton resource='client' id={client?.id || id} />
                </div>
                {(client?.id || id) && (
                  <CopyCode label='Código do cliente:' value={client?.id || id} className='mb-2' />
                )}
                <div className='text-muted fs-6 mb-4'>
                  {client?.email || (
                    <NotImported className='fs-6 text-gray-400 fw-semibold mb-0' />
                  )}
                </div>

                <div className='d-flex flex-wrap justify-content-start gap-3'>
                  <InfoTag label='CPF' icon='bi-person-vcard' value={client?.cpfResponsible} />
                  <InfoTag
                    label='Celular / WhatsApp'
                    icon='bi-whatsapp'
                    iconColor='#25D366'
                    value={client?.cellphone}
                    href={whatsappLink(client?.cellphone)}
                  />
                  <InfoTag label='Telefone' icon='bi-telephone' value={client?.telephone} />
                  <InfoTag
                    label='Instagram'
                    icon='bi-instagram'
                    iconColor='#E1306C'
                    value={client?.instagram ? `@${client.instagram}` : null}
                    href={
                      client?.instagram ? `https://instagram.com/${client.instagram}` : null
                    }
                  />
                </div>
              </div>
            </div>

            <div className={styles.panel}>
              <ul
                className={`nav nav-stretch nav-line-tabs nav-line-tabs-2x fw-bolder flex-nowrap border-0 ${styles.tabsNav}`}
                role='tablist'
              >
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.key
                  return (
                    <li className={`nav-item ${styles.tabItem}`} key={tab.key}>
                      <a
                        href='#'
                        role='tab'
                        aria-selected={isActive}
                        className={`nav-link bg-active-primary text-active-light text-hover-primary border-0 p-2 rounded m-0 ${
                          styles.tabLink
                        } ${isActive ? `active ${styles.tabLinkActive}` : 'text-gray-600'}`}
                        onClick={(event) => {
                          event.preventDefault()
                          setActiveTab(tab.key)
                        }}
                      >
                        <i className={`bi ${tab.icon} fs-5 text-reset`}></i>
                        {tab.label}
                        <span className={styles.tabCount}>{tab.count}</span>
                      </a>
                    </li>
                  )
                })}
              </ul>

              <div key={activeTab} className={styles.tabContent} role='tabpanel'>
                {activeTab === 'plants' && (
                  <ListPlantsDetails plants={client?.plants} onSelectPlant={setSelectedPlant} />
                )}

                {activeTab === 'responsable' && (
                  <UserResponsableClient user={client?.user} onEdit={openEditUser} />
                )}

                {activeTab === 'unitBranch' && (
                  <UnitBranchLinkedClient unitBranchs={client?.unitBranchs} />
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedPlant && selectedPlant.type_plant === 'COMPOSTA' && (
        <ModalPlantComposite
          show={!!selectedPlant}
          plant={selectedPlant.id}
          handleClose={() => setSelectedPlant(null)}
        />
      )}

      {selectedPlant && selectedPlant.type_plant !== 'COMPOSTA' && (
        <ModalPlant
          show={!!selectedPlant}
          plant={selectedPlant.id}
          handleClose={() => setSelectedPlant(null)}
        />
      )}

      <ModalAddUpdateUser
        show={!!editingUser}
        id={editingUser ? editingUser.id : undefined}
        data={editingUser ? editingUser : undefined}
        handleClose={() => {
          setEditingUser(null)
          refetch()
        }}
      />
    </Modal>,
    modalsRoot
  )
}

export {ModalDetailsClient}
